import { hashKey, type QueryKey } from '@tanstack/react-query';
import { tenantStore } from './tokens';

/**
 * Hashes every query key under the active tenant slug, so two tenants can never share a cache
 * entry — even for identical keys. Scoping lives in the hash (not the key arrays) so the
 * per-feature key factories and their `invalidateQueries` filters keep matching structurally,
 * and no call site can forget to add the tenant segment.
 */
export function tenantScopedHashFn(queryKey: QueryKey): string {
  return hashKey([tenantStore.get() ?? '__no-tenant__', ...queryKey]);
}
